import InlineApiEnumValue, {
  InlineApiEnumValueProps,
} from "@/common/components/Enum/InlineApiEnumValue";
import { ApiEnumName, ApiEnumValue } from "@/common/services/enum";

export interface GeneralStatusEnumValueInlineProps extends Omit<
  InlineApiEnumValueProps<ApiEnumName>,
  "type" | "value"
> {
  statusEnumTypeName: Nil<string>;
  status: Nil<string>;
}

export default function GeneralStatusEnumValueInline({
  statusEnumTypeName,
  status,
  ...otherProps
}: GeneralStatusEnumValueInlineProps) {
  if (!statusEnumTypeName || !status) {
    return null;
  }

  return (
    <InlineApiEnumValue
      type={statusEnumTypeName as ApiEnumName}
      value={status as ApiEnumValue<ApiEnumName>}
      withHelperTooltip
      {...otherProps}
    />
  );
}
